import { c as _c } from "react/compiler-runtime";
import { useEffect, useCallback, useRef, useState } from "react";
const useHorizontalScroll = callback => {
  const $ = _c(5);
  const observer = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  let t0;
  if ($[0] !== callback || $[1] !== isLoading) {
    t0 = node => {
      if (isLoading) {
        return;
      }
      if (observer.current) {
        observer.current.disconnect();
      }
      observer.current = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting && !isLoading) {
          setIsLoading(true);
          callback().finally(() => setIsLoading(false));
        }
      }, {
        rootMargin: "0px 0px 0px -10px",
        threshold: 0.1
      });
      if (node) {
        observer.current.observe(node);
      }
    };
    $[0] = callback;
    $[1] = isLoading;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const lastElementRef = t0;
  let t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => () => {
      if (observer.current) {
        observer.current.disconnect();
      }
    };
    t2 = [];
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  return lastElementRef;
};
export default useHorizontalScroll;